import React from 'react'
import CategoriesGrid from './CategoriesGrid'

const Categories = () => {


  return (
    <div id="category" className="scroll-mt-20">


<h1 className="
  text-center
  font-raleway
  font-regular
  text-2xl
  md:text-4xl
  tracking-wide
  text-gray-900
  mt-8
  md:mt-16
">
  Nos Catégories
</h1>



<CategoriesGrid/>


    </div>
  )
}

export default Categories